module.exports = __webpack_public_path__ + "img/sld_acdb_dark.88a6fde1.svg";